export default class Image {
  id = ''
  name = ''
  seqNum = 0
  original = ''
  small = ''
  middle = ''
  middleOssKey = ''
  big = ''
  bigOssKey = ''
  date = ''
  active = false
  selected = false
  mode = 0
  userSelectMode = 1
  colorMode = 0
  // 前端定义属性
  rotateDeg = 0
  imageScale = 1
  animated = true
  ocrLanguageKey = ''
  ocrContent = ''

  naturalWidth = 0
  naturalHeight = 0
  maxWidth = 180
  maxHeight = 180
  showWidth = 180
  showHeight = 180
  loadData = function (jsonData) {
    this.id = jsonData.id
    this.name = jsonData.name
    this.seqNum = jsonData.seqNum
    this.original = jsonData.original
    this.small = jsonData.small
    this.middle = jsonData.middle
    this.middleOssKey = jsonData.middleOssKey
    this.big = jsonData.big
    this.bigOssKey = jsonData.bigOssKey
    this.date = jsonData.date
    this.mode = jsonData.mode
    this.userSelectMode = jsonData.userSelectMode
    this.colorMode = jsonData.colorMode
    this.ocrLanguageKey = jsonData.ocrLanguage
  }

  // 解析纸张处理的结果
  loadPageModeResult = function (jsonData) {
    if (Array.isArray(jsonData)) {
      this.id = jsonData[0].id
      this.seqNum = jsonData[0].seqNum
      this.original = jsonData[0].original
      this.small = jsonData[0].ossSmallKeyUrl
      this.middle = jsonData[0].url
      this.middleOssKey = jsonData[0].ossKey
      this.big = jsonData[0].ossBigKeyUrl
      this.bigOssKey = jsonData[0].ossBigKey
    } else {
      this.id = jsonData.id
      this.seqNum = jsonData.seqNum
      this.original = jsonData.original
      this.small = jsonData.ossSmallKeyUrl
      this.middle = jsonData.url
      this.middleOssKey = jsonData.ossKey
      this.big = jsonData.ossBigKeyUrl
      this.bigOssKey = jsonData.ossBigKey
    }
  }

  loadEditorResult = function (jsonData) {
    console.log(this.id, jsonData.id)
    if (this.id === jsonData.fileId) {
      this.small = jsonData.ossSmallKeyUrl
      this.middle = jsonData.ossMiddleKeyUrl
      this.middleOssKey = jsonData.ossMiddleKey
      this.big = jsonData.ossKeyUrl
      this.bigOssKey = jsonData.ossKey
      this.rotateDeg = 0
    }
  }

  loadShareFileData = function (jsonData) {
    this.id = jsonData.id
    this.name = jsonData.fileName
    this.original = jsonData.original
    this.small = jsonData.small
    this.middle = jsonData.middle
    this.big = jsonData.original
  }

  isSameMiddle = function (imageSrc) {
    var isSame = false
    if (imageSrc === this.middle) {
      isSame = true
    }
    return isSame
  }

  isSameSmall = function (imageSrc) {
    var isSame = false
    if (imageSrc === this.small) {
      isSame = true
    }
    return isSame
  }

  computeShowSize = function (width, height) {
    this.naturalWidth = width
    this.naturalHeight = height
    var scaleW = this.naturalWidth / this.maxWidth
    var scaleH = this.naturalHeight / this.maxHeight
    var scale = (scaleW > scaleH) ? scaleW : scaleH
    this.showWidth = this.naturalWidth / scale
    this.showHeight = this.naturalHeight / scale
  }

  // 对象复制
  copyObj = function () {
    var copy = new Image()
    for (var i in this) {
      copy[i] = this[i]
    }
    return copy
  }
}



// WEBPACK FOOTER //
// ./src/common/model/Image.js